module.exports = __webpack_public_path__ + "img/购物.fcc17de1.jpg";